import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { environment } from "../../../environments/environment";
import { selectLoggedInUserId } from "../../../Store/features/user/userSlice";
import About from "./About/About";
import { toast } from "react-hot-toast";
import "./PublicCommunityView.scss";
import PostCard from "../../PublicPostPage/PostCard/PostCard";
import {
	getWebinarsByCommunityId,
	getAllCommunityAdminPostsAPI,
} from "../../../Service/user";
import { sendOTP, verifyOTP, postUserLogin } from "../../../Service/user";
import { loginSuccess } from "../../../Store/features/user/userSlice";
import avatar4 from "../../../Images/avatars/image-2.png";
import Picture1 from "../../../pages/StartUp/Resources/ResourcesNew/images/Picture1.png";
import Picture2 from "../../../pages/StartUp/Resources/ResourcesNew/images/Picture2.png";
import Register from "../../../components/Register/Register";
import Modal from "react-modal";
import { load } from "@cashfreepayments/cashfree-js";
import { createPaymentSession, verifyPayment, joinCommunity } from "../../../Service/user";
import PurchasePopup from "../../Shared/PurchasePopup/PurchasePopup";
Modal.setAppElement("#root");


const PublicCommunityView = () => {
	const { communityId } = useParams();
	const navigate = useNavigate();
	const location = useLocation();
	const [community, setCommunity] = useState(null);
	const loggedInUserId = useSelector(selectLoggedInUserId);
	const [adminPosts, setAdminPosts] = useState([]);
	const [showSignupModal, setShowSignupModal] = useState(false);
	const [showOtpModal, setShowOtpModal] = useState(false);
	const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
	const [orderId, setOrderId] = useState("");
	const [otp, setOtp] = useState(["", "", "", "", "", ""]);
	const inputRefs = useRef([]);
	const [formData, setFormData] = useState({
		firstName: "",
		lastName: "",
		email: "",
		phoneNumber: "",
		userType: "startup founder",
		registeredFrom: "community-page",
	});
	const dispatch = useDispatch();
	const [isJoining, setIsJoining] = useState(false);
	const [showSuccessModal, setShowSuccessModal] = useState(false);
	const [webinars, setWebinars] = useState([]);
	const [joiningCommunityId, setJoiningCommunityId] = useState(null);
	const [showPaymentModal, setShowPaymentModal] = useState(false);
	const [selectedCommunity, setSelectedCommunity] = useState(null);

	const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));

	useEffect(() => {
		fetchCommunityDetails();
	}, [communityId]);

	useEffect(() => {
		if (community) {
			fetchAdminPosts();
		}
	}, [community]);

	// fetch community webinars
	useEffect(() => {
		getWebinarsByCommunityId(communityId)
			.then((response) => {
				if (response && response.data) {
					setWebinars(response.data);
				} else {
					console.error("Error fetching webinars:", response);
				}
			})
			.catch((error) => {
				console.error("Error fetching webinars:", error);
			});
	}, [communityId]);

	const fetchCommunityDetails = async () => {
		try {
			const response = await axios.get(
				`${environment.baseUrl}/communities/getCommunityById/${communityId}`
			);
			setCommunity(response.data.data);
		} catch (error) {
			console.error("Error fetching community:", error);
		}
	};

	const fetchAdminPosts = async () => {
		try {
			const response = await getAllCommunityAdminPostsAPI(communityId, community?.adminId._id);
			const postsData = Array.isArray(response.data)
				? response.data
				: Array.isArray(response.data?.data)
				? response.data.data
				: [];
			const communityPosts = postsData.slice(0, 3);
			setAdminPosts(communityPosts);
		} catch (error) {
			console.error("Error fetching admin posts:", error);
		}
	};

	const handleLockedContentClick = () => {
		if (!loggedInUserId) {
			setShowSignupModal(true);
		} else {
			handleJoinCommunity();
		}
	};

	const handleJoinCommunity = async () => {

		if (!loggedInUserId) {
			setShowSignupModal(true);
		} 
		else {
		if (!community?.isOpen) {
			toast.error("This community is closed for new members");
			return;
		}

		// Check if the community is paid
		if (community.subscription === "paid") {
			setShowPaymentModal(true);
			return;
		}
		 // Check if the user is already a member
		 if (community.members.some((member) => member.member?._id === loggedInUserId)) {
			toast.error("You are already a member of this community");
			return;
		  }
		}
	
		  try { 
			setIsJoining(true);
			await joinCommunity(communityId, { memberIds: [loggedInUserId] });
			toast.success('Successfully joined the community!');
			window.location.reload();
		  } catch (error) {
			console.error('Error joining community:', error);
			toast.error('Failed to join community');
		  } finally {
			setIsJoining(false);
		  }
	};
  // Initialize Cashfree SDK
  const initializeCashfree = async () => {
    try {
      return await load({ mode: "production" });
    } catch (error) {
      console.error("Failed to initialize Cashfree:", error);
      throw error;
    }
  };

	const handlePaymentSuccess = async (userDetails) => {
		try {
		  const cashfree = await initializeCashfree();
	
		  
			const paymentResponse = await createPaymentSession({
			  name: userDetails.name,
			  email: userDetails.email,
			  mobile: userDetails.mobile,
			  amount: community.amount,
			  entityId: community._id,
			  entityType: "community",
			});
	
			const { order_id, payment_session_id } = paymentResponse.data;
	
			await cashfree.checkout({
			  paymentSessionId: payment_session_id,
			  redirectTarget: "_modal",
			});
	
			const verificationResponse = await verifyPayment({
			  orderId: order_id,
			  entityId: community._id,
			  entityType: "community",
			});
	
			if (verificationResponse.data.status === "SUCCESS") {
			  await joinCommunity(communityId, { memberIds: [loggedInUserId] });
			  toast.dismiss();
			  toast.success("Community joined successfully");
			  window.location.reload();
		  }
		} catch (error) {
		  console.error("Payment error:", error);
		  toast.dismiss();
		  toast.error("Payment process failed. Please try again.");
		} finally {
		  setShowPaymentModal(false);
		}
	  };



	const handleOtpVerify = async () => {
		setIsVerifyingOtp(true);
		try {
			const verificationCode = otp.join("");

			const otpResponse = await verifyOTP({
				otp: verificationCode,
				orderId,
				phoneNumber: `+91${formData.phoneNumber}`,
			});

			if (otpResponse.isOTPVerified) {

				// First register the user
				const registrationData = {
					...formData,
					isInvestor: formData.userType === "investor",
					registeredFrom: "community-page",
				};

				const registrationResponse = await axios.post(
					`${environment.baseUrl}/users/registerUser`,
					registrationData
				);

				// Then login the user
				const loginResponse = await postUserLogin({
					phoneNumber: formData.phoneNumber,
				});

				if (loginResponse?.user && loginResponse?.token) {
					const { user, token } = loginResponse;

					// Store user data
					localStorage.setItem("accessToken", token);
					localStorage.setItem("isLoggedIn", "true");
					localStorage.setItem("user", JSON.stringify(user));

					// Update Redux state
					dispatch(loginSuccess(user));

					// Close modals
					setShowOtpModal(false);
					setShowSignupModal(false);

					toast.success("Successfully registered and logged in!");

					// Join community
					await handleJoinCommunity();
				} else {
					console.error("Login response missing user or token:", loginResponse);
					toast.error("Login failed after registration");
				}
			} else {
				console.error("OTP verification failed:", otpResponse);
				toast.error("Invalid OTP. Please try again.");
			}
		} catch (error) {
			console.error("Error in handleOtpVerify:", error);
			toast.error(error.response?.data?.message || "Registration failed");
		} finally {
			setIsVerifyingOtp(false);
			setOtp(["", "", "", "", "", ""]); // Reset OTP input
		}
	};

	const handleOtpChange = (index, value) => {
		const newOtp = [...otp];
		newOtp[index] = value;
		setOtp(newOtp);

		// Auto-focus next input
		if (value && index < 5) {
			inputRefs.current[index + 1].focus();
		}
	};

	const handleKeyDown = (index, e) => {
		// Handle backspace
		if (e.key === "Backspace" && !otp[index] && index > 0) {
			const newOtp = [...otp];
			newOtp[index - 1] = "";
			setOtp(newOtp);
			inputRefs.current[index - 1].focus();
		}
	};

	const renderOtpModal = () => (
		<Modal
			isOpen={showOtpModal}
			onRequestClose={() => {
				setShowOtpModal(false);
				setOtp(["", "", "", "", "", ""]);
			}}
			className="public-community-modal-content"
			overlayClassName="modal-overlay"
			shouldCloseOnOverlayClick={!isVerifyingOtp}
		>
			<div className="modal-header">
				<h2>Enter verification code</h2>
				<button
					onClick={() => {
						setShowOtpModal(false);
						setOtp(["", "", "", "", "", ""]);
					}}
					disabled={isVerifyingOtp}
				>
					×
				</button>
			</div>
			<p>We have just sent a verification code to your mobile number.</p>
			<div className="otp-container">
				{otp.map((digit, index) => (
					<input
						key={index}
						ref={(el) => (inputRefs.current[index] = el)}
						type="text"
						maxLength="1"
						value={digit}
						onChange={(e) => handleOtpChange(index, e.target.value)}
						onKeyDown={(e) => handleKeyDown(index, e)}
						disabled={isVerifyingOtp}
					/>
				))}
			</div>
			<button
				onClick={handleOtpVerify}
				disabled={isVerifyingOtp || otp.join("").length !== 6}
			>
				{isVerifyingOtp ? "Verifying..." : "Verify"}
			</button>
		</Modal>
	);

	const renderSuccessModal = () => (
		<Modal
			isOpen={showSuccessModal}
			onRequestClose={() => setShowSuccessModal(false)}
			className="public-community-modal-content success-modal"
			overlayClassName="modal-overlay"
		>
			<div className="modal-header">
				<h2>Congratulations! 🎉</h2>
				<button onClick={() => setShowSuccessModal(false)}>×</button>
			</div>
			<p>You are now a part of {community?.name}!</p>
			<button
				onClick={() => {
					setShowSuccessModal(false);
					window.location.reload();
				}}
				className="explore-button"
			>
				Explore the Community
			</button>
		</Modal>
	);

	const formatDate = (dateString) => {
		const options = {
			year: "numeric",
			month: "long",
			day: "numeric",
			// hour: "2-digit",
			// minute: "2-digit",
			// hour12: true,
		};

		const date = new Date(dateString);
		return date.toLocaleDateString("en-IN", options);
	};

	return (
		<div className="public-community-view">
			<About community={community} setShowSignupModal={setShowSignupModal} handleJoinCommunity={handleJoinCommunity} />

			{/* Posts Section */}
			{adminPosts?.length > 0 && <div className="content-section posts-section">
				<h3>
					<span>Recent Posts from Admin</span>
					<button className="section-cta" onClick={handleLockedContentClick}>
						Join the Community
					</button>
				</h3>
				<div className="admin-posts-content locked-content">
					{adminPosts.map((post) => (
						<PostCard
							key={post._id}
							firstName={post.user.firstName}
							lastName={post.user.lastName}
							profilePicture={post.user.profilePicture || avatar4}
							oneLinkId={post.user.oneLinkId}
							isSubscribed={false}
							startUpCompanyName={post.user.startUp}
							investorCompanyName={post.user.investor}
							designation={post.user.designation}
							location={post.user.location}
							description={post.description}
							video={post.video}
							image={post.image}
							images={post.images}
							createdAt={post.createdAt}
							likes={post.likes}
							comments={post.comments}
							pollOptions={post.pollOptions}
							userName={post.user.userName}
							communityPublic={true}
						/>
					))}
					<div className="locked-overlay" onClick={handleLockedContentClick}>
						<div className="lock-message">
							{loggedInUserId
								? "Join community to access all posts"
								: "Sign up to access all posts"}
						</div>
					</div>
				</div>
			</div>}

			{/* Products Section */}
			{community?.products?.length > 0 && <div className="content-section products-section">
				<h3>
					<span>Community Products</span>
					<button className="section-cta" onClick={handleLockedContentClick}>
						Join the Community
					</button>
				</h3>
				<div className="products-grid locked-content">
					{(community?.products?.length > 0
						? community.products.slice(0, 3)
						: []
					).map((product) => (
						<div key={product._id} className="product-card">
							<div className="product-image">
								<img src={product.image} alt={product.name} />
								{/* <span className={`badge ${product.is_free ? "free" : "paid"}`}>
									{product.is_free ? "Free" : `₹${product.amount}`}
								</span> */}
							</div>
							<div className="product-content">
								<h4>{product.name}</h4>
								<p>{product.description}</p>
							</div>
						</div>
					))}
					<div className="locked-overlay" onClick={handleLockedContentClick}>
						<div className="lock-message">
							{loggedInUserId
								? "Join community to access products"
								: "Sign up to access products"}
						</div>
					</div>
				</div>
			</div>}

			{/* Events Section */}
		{webinars?.length > 0 && <div className="content-section events-section">
				<h3>
					<span>Upcoming Events</span>
					<button className="section-cta" onClick={handleLockedContentClick}>
						Join the Community
					</button>
				</h3>
				<div className="events-grid locked-content">
					{(webinars?.length > 0 ? webinars : []).map((event) => (
						<div key={event._id} className="event-card">
							<div className="event-info">
								<h3>{event.title}</h3>
								<div className="event-meta">
									<div className="leftTime">
										<span>{formatDate(event.date)}</span>
										<span className="separator"> | </span>
										<span>{event.duration} min.</span>
									</div>
									<div className="price-tag">
										{event.price > 0 ? `₹${event.price}` : "Free"}
									</div>
								</div>
							</div>
						</div>
					))}
					<div className="locked-overlay" onClick={handleLockedContentClick}>
						<div className="lock-message">
							{loggedInUserId
								? "Join community to access events"
								: "Sign up to access events"}
						</div>
					</div>
				</div>
			</div>}

			{/* Join Button */}
			<div className="btn-center">
				{!community?.members?.some(
					(member) => member?.member?._id === loggedInUserId
				) &&
					community?.isOpen &&
					community?.adminId !== loggedInUserId && (
						<button
							className="join-button"
							disabled={joiningCommunityId === community._id}
							onClick={handleJoinCommunity}
						>
							{!loggedInUserId
								? "Join Community"
								: joiningCommunityId
								? "Joining..."
								: "Join Community"}
						</button>
					)}
			</div>

			{showSignupModal && (
				<div className="modal-overlay">
					<Register
						setShowSignupModal={setShowSignupModal}
						registeredFrom={window.location.pathname}
						closeButton={true}
					/>
				</div>
			)}
			      {showPaymentModal && (
         
        <PurchasePopup
          isOpen={showPaymentModal}
          onClose={() => setShowPaymentModal(false)}
          itemDetails={{
            type: "community",
            name: community?.name,
            memberCount: community?.members.length,
            isOpen: community?.isOpen,
            description: community?.about,
            amount: community?.amount,
            is_free: community?.subscription === "free",
          }}
          loggedInUser={loggedInUser}
          onProceed={handlePaymentSuccess}
        />
      )}
			{renderOtpModal()}
			{renderSuccessModal()}
		</div>
	);
};

export default PublicCommunityView;
